import React from 'react';

import { HashLink as Link } from 'react-router-hash-link';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  
  const footerSections = [
    {
      title: "About IGM",
      links: [
        { name: "Our Story", path: "/about", id: "our-story" },
        { name: "Our Four-Pillar Approach", path: "/about", id: "six-pillar" },
        { name: "Leadership Team", path: "/about", id: "team" },
        { name: "Transparency Metrics", path: "/about", id: "transparency-metrics" },
        { name: "Photo Gallery", path: "/gallery", id: "gallery" },
        { name: "Contact Us", path: "/contact", id: "contact" }
      ]
    },
    {
  title: "Our Work",
  links: [
    { name: "All Programs", path: "/projects", category: "" },
    { name: "Education", path: "/projects", category: "Education" },
    { name: "Healthcare", path: "/projects", category: "Healthcare" },
    { name: "Family Reunification", path: "/projects", category: "Family Reunification" }
  ]
}
,
    {
      title: "Get Involved",
      links: [
        { name: "Donate Now", path: "/donate", id: "donate-now" },
        { name: "Sponsor a Child", path: "/", id: "sponsor" },
        { name: "Volunteer", path: "/contact", id: "volunteer" }
      ]
    }
  ];

  const socialLinks = [
    { name: "Facebook", icon: "Facebook", url: "https://www.facebook.com/igmchildren.home/" },
   
    { name: "Instagram", icon: "Instagram", url: "https://www.instagram.com/igmchildrenhome/" },
    { name: "LinkedIn", icon: "Linkedin", url: "https://www.linkedin.com/in/igm-children-home-001594351/" },
    { name: "YouTube", icon: "Youtube", url: "https://www.youtube.com/@igmchildrenhome3093" }
  ];

  

  return (
    <footer className="bg-foreground text-white">
      {/* Main Footer */}
      <div className=" mx-auto px-6 md:px-8 xl:px-48  py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Link to="/homepage" className="mb-6 inline-block">
  <img
    src="/assets/images/igm-logo-light.png"
    alt="IGM Children Homes"
    className="h-16 w-auto"
  />
</Link>
            
            <p className="font-body text-white/80 leading-relaxed mb-6">
              Since 1975, we've been restoring broken lives and building brighter futures for children in need. Every child deserves a chance to dream.
            </p>

            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Icon name="MapPin" size={16} className="text-sky-blue flex-shrink-0" />
                <span className="font-body text-sm text-white/80">
                  No:3, IGM Campus,Church street, Veerabaghu Nagar, Guduvancheri, 603202, Chennai.
                </span>
              </div>
              
              <div className="flex items-center space-x-3">
                <Icon name="Phone" size={16} className="text-sky-blue flex-shrink-0" />
                <span className="font-body text-sm text-white/80">
                  9087444321 / 9962444321
                </span>
              </div>
              
              <div className="flex items-center space-x-3">
                <Icon name="Mail" size={16} className="text-sky-blue flex-shrink-0" />
                <span className="font-body text-sm text-white/80">
                  igm_Joe@yahoo.co.in, igmchildrenhome@yahoo.com
                </span>
              </div>
            </div>
          </div>

          {footerSections?.map((section, index) => (
  <div key={index}>
    <h3 className="font-heading font-bold text-xl text-white mb-6">
      {section?.title}
    </h3>
    <ul className="space-y-3">
      {section?.links?.map((link, linkIndex) => (
        <li key={linkIndex}>
          <Link
            to={
              section.title === "Our Work" && link.category
                ? `${link.path}?category=${encodeURIComponent(link.category)}`
                : link.id
                ? `${link.path}#${link.id}`
                : link.path
            }
            smooth
            className="font-body text-white/80 hover:text-sky-blue transition-colors text-sm"
          >
            {link?.name}
          </Link>
        </li>
      ))}
    </ul>
  </div>
))}

        </div>

        
      </div>
      {/* Bottom Footer */}
      <div className="border-t border-white/20">
        <div className=" mx-auto px-6 md:px-8 xl:px-48  py-8">
          <div className="flex flex-col md:flex-row md:items-center justify-between space-y-8 md:space-y-0">
            {/* Copyright */}
            <div className="font-body text-white/60 text-sm text-left">
              © {currentYear} IGM Children Homes. All rights reserved. | 
              <span className="text-white/80"> Registered under Section 12A & 80G</span>
            </div>

            {/* 🔥 BOTTOM BAR */}
      
        <div className="">

        

          <a
            href="https://rthree.in"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm md:text-base"
          >
            Powered by <span className="font-bold text-sm md:text-base">RThree Creatives</span>
          </a>

        </div>
      

            {/* Social Links */}
            <div className="flex items-center space-x-4">
              <span className="font-body text-white/60 text-sm mr-2">Follow us:</span>
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 hover:bg-sky-blue/20 rounded-lg flex items-center justify-center transition-colors group"
                  aria-label={social?.name}
                >
                  <Icon 
                    name={social?.icon} 
                    size={18} 
                    className="text-white/80 group-hover:text-sky-blue transition-colors" 
                  />
                </a>
              ))}
            </div>
          </div>

          {/* Legal Links
          <div className="mt-6 pt-6 border-t border-white/10 text-center">
            <div className="flex flex-wrap justify-center gap-6">
              <Link to="/about" className="font-body text-white/60 hover:text-white text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/about" className="font-body text-white/60 hover:text-white text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="/about" className="font-body text-white/60 hover:text-white text-sm transition-colors">
                Refund Policy
              </Link>
              <Link to="/about" className="font-body text-white/60 hover:text-white text-sm transition-colors">
                Transparency Report
              </Link>
            </div>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;